module.exports = __webpack_public_path__ + "img/tref-griffiths.1ad080b1.jpg";